import { useTranslation } from "react-i18next";

import { Button, Skeleton } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { l } from "@shared/locales/i18n";

import * as styles from "./MobileFilterFooter.styles";

interface Props {
  onClearFilters?: () => void;
  resultCount?: number;
  hideClearAllButton?: boolean;
  isLoading: boolean;
}

const MobileFilterFooter = ({
  resultCount,
  onClearFilters,
  hideClearAllButton,
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const {
    setActiveSearchType,
    activeFilters,
    activeBrands,
    activeIngredients,
    excludedIngredients,
    activeSupplementTypes,
    activeConditions,
    activeCategories,
    isOnlyShowFavorites,
    isOnlyShowInStock,
    isFsTested,
  } = useCatalogSearch();

  const filterCount =
    (activeFilters?.length ?? 0) +
    (activeBrands?.length ?? 0) +
    (activeIngredients?.length ?? 0) +
    (excludedIngredients?.length ?? 0) +
    (activeSupplementTypes?.length ?? 0) +
    (activeConditions?.length ?? 0) +
    (activeCategories?.length ?? 0) +
    (isOnlyShowFavorites ? 1 : 0) +
    (isOnlyShowInStock ? 1 : 0) +
    (isFsTested ? 1 : 0);

  const renderShowProductsButton = () => {
    if (resultCount || resultCount === 0) {
      return (
        <Button
          css={[styles.button, styles.seeButton]}
          onClick={() => setActiveSearchType("")}
          isLoading={isLoading}
        >
          {t(l.sharedCatalog.filter.ShowProducts, { count: resultCount })}
        </Button>
      );
    }

    return <Skeleton type="button" css={styles.button} />;
  };

  const clearAllButton = !hideClearAllButton && (
    <Button
      isColor="system"
      css={[styles.button, styles.clearButton]}
      onClick={onClearFilters}
      disabled={filterCount === 0 || !onClearFilters}
    >
      {t(l.sharedCatalog.filter.Clear, { numberOfFilters: filterCount })}
    </Button>
  );

  const containerStyles = [
    styles.container,
    tablet.lessThan && styles.tabletContainer,
    hideClearAllButton && styles.centered,
  ];

  return (
    <div css={containerStyles}>
      {clearAllButton}
      {renderShowProductsButton()}
    </div>
  );
};

export { MobileFilterFooter };
